import NoticeMessageLayout from '#/atoms/notice-message-layout';
import {ExclamationCircleIcon} from '@heroicons/react/24/outline';
import {ChevronDownIcon} from '@heroicons/react/24/solid';
import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';
import {useToggle} from 'react-use';
import {BaseError} from 'viem';

export const NoticeMessageErrorDetails: FunctionComponent<{error: Error | BaseError}> = ({error}) => {
  const {t} = useTranslation('translation');

  const [expanded, toggle] = useToggle(true);

  return (
    <NoticeMessageLayout className='space-y-3 shrink-0' pxClassName='px-3' pyClassName='py-3' theme={'error'}>
      {expanded && (
        <div className='border-b pb-3 border-redNotice/50'>
          <div className='text-sm font-bold'>{error.name}</div>
          <div className={'text-sm mt-2 transition-all duration-200'}>
            {error instanceof BaseError ? error.shortMessage : error.message}
          </div>
        </div>
      )}

      <button className='flex items-center gap-3 group/error-tile' onClick={toggle}>
        <ExclamationCircleIcon className='w-8 h-8 mx-0.5 stroke-[1.5] stroke-redNotice' />

        <div className='grow text-sm font-semibold text-left'>
          {t('components.noticeMessageErrorDetails.buttonMessage')}
        </div>

        <div className='text-xs mt-0.5 font-bold self-start text-redNotice flex justify-end items-center gap-1 whitespace-nowrap group-hover/error-tile:opacity-70'>
          <ChevronDownIcon
            className={`w-4 h-4 stroke-redNotice fill-redNotice ${expanded ? '-scale-100' : ''} transition-transform`}
          />
          {t('components.noticeMessageErrorDetails.buttonAction')}
        </div>
      </button>
    </NoticeMessageLayout>
  );
};
